"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passKeyGetValue = void 0;
var _isEmpty = require("../is-empty");
// import { alterNomenclature } from '../../index'

/** 通过 key 值获取 对象中的 value
 * @description: 通过 key 值获取 对象中的 value
 * @param { Object } obj 要查找的 对象
 * @param { String } key 要找的 key
 * @param { Boolean } vague key 是否模糊？如果模糊的话，就不区分大小驼峰、下划线、短横线命名
 * @return { * } obj 对象中 key 对应的 value
 */
var passKeyGetValue = exports.passKeyGetValue = function passKeyGetValue(obj, key) {
  var vague = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if ((0, _isEmpty.isEmpty)(obj) || (0, _isEmpty.isEmpty)(key) || typeof key !== 'string') return false;
  if (!vague) return obj[key];

  // const k = alterNomenclature(key, '_')

  return '';
};